
export function defaultDataTransformer(response) {
  return response.json().then(result => result)
}

export function fetcher(resource, init = {}) {
  return fetch(resource, init)
}

export function transformDataFetcher(f, transformer) {
  return function () {
    return f.apply(this, arguments).then(transformer)
  }
}

export function raiseHttpErrorTransformer(response) {
  if (!response.ok) {
    throw response
  }
  return response
}



// WEBPACK FOOTER //
// ./src/js/resource/transformer.js